<template>
<div>
	<template v-if="pendingDeleteEvents.length > 0">
		<h3>Events Pending Deletion (subject to your approval)</h3>

		<table-list
			record-name="Event"
			:fields="[
				{label: 'Start',key: 'startDate'},
				{label: 'End',key: 'endDate'},
				{label: 'Duration',key: 'duration'},
				{label: 'Type',key: 'type'},
				{label: 'Project/Service',key: 'jobNum'},
				{label: 'Status',key:'status'}
			]"
			:records="mutatedDeleteEvents"
			:other-buttons="[
				{
					text: 'Approve Delete',
					click: 'approveDelete',
					title: 'Approve deletion request',
					class: 'btn-dark',
					icon: 'fa-check'
				},
				{
					text: 'Reject Delete',
					click: 'rejectDelete',
					title: 'Reject deletion request',
					class: 'btn-danger',
					icon: 'fa-times'
				}
			]"
			v-on:approveDelete="approveDelete">
		</table-list>
	</template>

	<h2>Calendar Events for {{$store.employee.first_name}} {{$store.employee.last_name}}: Last 12 Months</h2>

	<div class="row">
		<div class="col-lg-8">
			<table-list
				record-name="Event"
				:fields="fields"
				:records="mutatedEvents"
				:has-delete="$store.userDetails.id != $store.employee.id"
				delete-endpoint="ScheduleEvent/delete"
				:total-paginated-records="totalPaginatedRecords"
				:other-buttons="[
					{
						text: 'Approve Delete',
						condition: ['deleteRequested',true],
						click: 'approveDelete',
						title: 'Approve deletion request',
						class: 'btn-dark',
						icon: 'fa-check'
					}
				]"
				v-on:approveDelete="approveDelete">

				<button-group :tab-styling="true" :buttons="filterButtons" class="mb-2" v-model="filterValue" v-on:change="fetchEvents">
				</button-group>

				<div class="d-flex flex-row flex-wrap align-items-center">.
					<strong class="mr-4">By Page: </strong>
					<info-box label="Sick Days" :value="eventTotals.numSickDaysUsed" :stacked="true" class="mr-1"></info-box>
					<info-box label="Partial Sick Days" :value="eventTotals.partialSickDayHrsUsed+' hrs over '+ eventTotals.numPartialSickDays+' days'" :stacked="true" class="mr-1"></info-box>
					<info-box label="Vacation Days Used" :value="eventTotals.numVacationUsed" :stacked="true" class="mr-1"></info-box>
					<info-box label="Vacation Days Scheduled" :value="eventTotals.numVacationScheduled" :stacked="true" class="mr-1"></info-box>

					<div class="ml-auto">
						<button class="btn btn-success" v-on:click="addEvent">
							<i class="fa fa-plus"></i>
							Add Event
						</button>
					</div>
				</div>

			</table-list>

			<pagination :pages="numPages"
				:current-page="page"
				v-on:pageChange="pageChange">
			</pagination>
		</div>
		<div class="col-lg-4">
			<widget v-if="($store.employee.id == $store.userDetails.id || hasModulePermRead('Users')) && eventTotalsSinceReset.numSickDaysUsed !== false" title="Time Off">
			<p>Since {{resetDate.format("MMM, D, YYYY")}}</p>
			<table class="days-off-table table table-sm">
				<tr class="sick-days">
					<th>Sick Days:</th>
					<td>{{eventTotalsSinceReset.numSickDaysUsed}}</td>
				</tr>
				<tr class="sick-days">
					<th>Partial Sick Days:</th>
					<td>{{eventTotalsSinceReset.partialSickDayHrsUsed}} hrs over {{eventTotalsSinceReset.numPartialSickDays}} days</td>
				</tr>
				<tr class="vacation-days">
					<th>Vacation Days Used:</th>
					<td>{{eventTotalsSinceReset.numVacationUsed}}</td>
				</tr>
				<tr class="vacation-days">
					<th>Vacation Days Scheduled:</th>
					<td>{{eventTotalsSinceReset.numVacationScheduled}}</td>
				</tr>
				<tr class="vacation-days">
					<th>Vacation Days Remaining:</th>
					<td>{{numVacationRemaining}}</td>
				</tr>
			</table>
		</widget>
		</div>	
	</div>

	<schedule-event-edit-modal :visible="editModal.visible"
		:record="editModal.record"
		v-on:eventSaved="fetchEvents"
		v-on:closeModal="editModal.visible = false">
	</schedule-event-edit-modal>
</div>
</template>
<script type="text/javascript">
import EventsMixins from "@/mixins/EventsMixins.js"
import ScheduleMixins from "@/mixins/ScheduleMixins.js"

import TableList from "@/components/TableList"
import InfoBox from "@/components/InfoBox"
import ButtonGroup from "@/components/ButtonGroup"
import Pagination from "@/components/Pagination"
import Widget from "@/components/Widget"

import ScheduleEventEditModal from "@/components/super_components/ScheduleEventEditModal"

export default {
	name: "EmployeeEvents",
	components: {
		TableList,
		InfoBox,
		ButtonGroup,
		ScheduleEventEditModal,
		Pagination,
		Widget
	},
	mixins: [EventsMixins,ScheduleMixins],
	data() {
		return {
			eventsForEventTotals: [],
			page: 1,
			numPages: null,
			totalPaginatedRecords: 0,
			pendingDeleteEvents: [],
			filterValue: "last-12",
			fields: [
				{label: 'Start',key: 'startDate'},
				{label: 'End',key: 'endDate'},
				{label: 'Duration',key: 'duration'},
				{label: 'Type',key: 'type'},
				{label: "Status",key:"status"}
			],
			editModal: {
				visible: false,
				title: "Edit Event",
				record: {}
			},
			eventTotalsSinceReset: {
				numSickDaysUsed: false,
				numVacationUsed: false,
				numVacationScheduled: false,
				partialSickDayHrsUsed: false,
				numPartialSickDays: false
			}
		}
	},
	watch: {
		'$store.employee'() {
			this.fetchEvents()
			this.fetchingPendingDeletes()
		}
	},
	computed: {
		filterButtons() {

			let buttons = [
				{text:'Last 12 mo',value:'last-12'},
			]

			buttons.push({text: this.moment().format("YYYY"),value:'this-year'})

			buttons.push({text: 'All Time',value:'all-time'})

			return buttons
		},
		mutatedDeleteEvents() {
			let vm = this

			return this.pendingDeleteEvents.map(event => vm.mutateEventItem(event))
		},
		mutatedEvents() {
			let vm = this

			return this.$store.scheduleEvents
				.map(event => vm.mutateEventItem(event))
		},
		numVacationRemaining() {
			if ("EmployeeSetting" in this.$store.employee && this.$store.employee.EmployeeSetting && this.$store.employee.EmployeeSetting.length > 0)
				return +this.$store.employee.EmployeeSetting[0].num_annual_vacation_days - +this.eventTotalsSinceReset.numVacationUsed

			return "Vacation not allocated"
		},
	},
	methods: {
		mutateEventItem(event) {
			let vm = this
			let formatString = "MMM D, YYYY"

			let durationMin = vm.moment(event.end_time).diff(event.start_time,"minutes")

			let durationUnit = " min"

			let duration = durationMin

			if (+durationMin < 60) 
				formatString += "@ h:mm a"
			else if (+durationMin < 24 * 60) {
				formatString += "@ h:mm a"
				duration = durationMin / 60

				duration = duration.round()

				durationUnit = " hrs"
			}
			else {
				duration = Math.floor(durationMin / 24 / 60) + 1
				durationUnit = " days"
			}

			event.duration = duration+durationUnit

			event.startDate = vm.moment.utc(event.start_time).local().format(formatString)
			event.endDate = vm.moment.utc(event.end_time).local().format(formatString)

			event.status = ""
			event.deleteRequested = false
			if (event.is_vacation == 1) {
				if (event.approved_by == 0 && event.rejected_by == 0) {
					event.status = "Unapproved (yet)"
				}
				else if ("ApprovedBy" in event && event.ApprovedBy)
					event.status = "Approved by "+event.ApprovedBy.first_name+" "+event.ApprovedBy.last_name
				else if ("RejectedBy" in event && event.RejectedBy)
					event.status = "Rejected by "+event.RejectedBy.first_name+" "+event.RejectedBy.last_name
			}
			if ("DeleteRequestedBy" in event && event.DeleteRequestedBy) {
				event.status = "Delete requested by "+event.DeleteRequestedBy.first_name + " " + event.DeleteRequestedBy.last_name
				event.deleteRequested = true
			}

			event.type = ""
			if (event.is_vacation == 1)
				event.type = "Vacation"
			else if (event.is_sickday == 1)
				event.type = "Sick Day"
			else if (event.is_off == 1)
				event.type = "Off Work"
			else if (event.service_id == 0 && event.job_id == 0)
				event.type = "Generic Event"
			else
				event.type = "Scheduled for Work"

			if ("Job" in event && event.Job)
				event.jobNum = "Project #"+event.Job.job_num
			else if ("Service" in event && event.Service)
				event.jobNum = "Service #"+event.Service.job_num

			event.isPast = vm.moment(event.start_time).isBefore(vm.moment())

			return event
		},
		addEvent() {
			this.editModal.visible = true

			this.editModal.record = {
				type: "user",
				user_id: this.$store.employee.id,
				job_id: 0,
				service_id: 0,
				is_vacation: 0,
				is_sickday: 0,
				is_off: 0
			}
		},
		approveDelete(event) {
			let vm = this
			this.postData("ScheduleEvent/delete",{id: event.id},true).then(response => {
				if (response.success) {
					vm.alertSuccess("Event deleted")
					vm.fetchEvents()
					vm.fetchingPendingDeletes()
				}
			})
		},
		rejectDelete(event) {
			let vm = this
			this.postData("ScheduleEvent/save",{id: event.id, delete_requested_by: 0},true).then(response => {
				if (response.success) {
					vm.fetchEvents()
					vm.fetchingPendingDeletes()
				}
			})
		},
		pageChange(page) {
			this.page = page
			this.fetchEvents()
		},
		fetchingPendingDeletes() {
			let vm = this

			let params = {
				filters: [
					["delete_requested_by >",0],
					["user_id",this.$store.employee.id]
				],
				include: [
					{model: "Service",fields: ["id","slug","job_num","job_name"]},
					{model: "Job",fields: ["id","slug","job_num","job_name"]},
					{model: "User",fields: ["id","slug","first_name","last_name"]}
				]
			}

			this.getJSON("ScheduleEvent/get",params).then(response => {

				if (response.success) 
					vm.pendingDeleteEvents = response.data
			})
		},
		fetchEvents() {
			let vm = this

			let params = {
				page: this.page,
				include: [{model: "User",fields: ["id","slug","first_name","last_name"]}]
			}

			if (vm.filterValue == 'last-12') {
				let yearAgo = this.moment().subtract(12,"months").format("YYYY-MM-DD")

				params.filters = [
					["start_time >=",yearAgo],
					["user_id",this.$store.employee.id]
				]
			}
			else if (vm.filterValue == 'this-year') {
				let currentYear = vm.moment().format("YYYY")

				params.filters = [
					["start_time >=",currentYear+"-01-01"],
					["start_time <=",currentYear+"-12-31"],
					["user_id",this.$store.employee.id]
				]
			}
			else {
				params.filters = [
					["user_id",this.$store.employee.id]
				]
			}

			params.filters.push(["service_id",0])
			params.filters.push(["job_id",0])

			this.spinner(true)

			this.getJSON("ScheduleEvent/get",params).then(response => {

				vm.spinner(false)

				let vacationUsed = 0
				let vacationScheduled = 0
				let sickUsed = 0

				if (response.success) {

					vm.eventTotals = vm.calcScheduleEventTypeTotals(response.data)

					vm.numPages = response.meta.num_pages

					vm.$store.scheduleEvents = response.data
					
				}
			})
		},
		fetchEventsSinceReset() {
			let vm = this

			let params = {
				filters: [
					["start_time >=",this.resetDate.format("YYYY-MM-DD")],
					["user_id",this.$store.employee.id],
					["job_id",0],
					["service_id",0]
				]
			}

			this.getJSON("ScheduleEvent/get",params).then(response => {
				if (response.success) {
					vm.eventTotalsSinceReset = vm.calcScheduleEventTypeTotals(response.data)
				}
			})
		},
	},
	created() {
		if ("id" in this.$store.employee) {
			this.fetchEvents()
			this.fetchingPendingDeletes()
			this.fetchEventsSinceReset()
		}
	}
}
</script>